import React, { useState } from "react";
import { ContactWrapper, Email } from "./ContactElements";
import { MdContentCopy } from "react-icons/md";
import { IconButton, Tooltip } from "@mui/material";
import Zoom from '@mui/material/Zoom';

import ScrollAnimation from "react-animate-on-scroll";
function Contact() {
  const [showTooltip, setShowTooltip] = useState(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText("markusjnilsson@hotmail.com");
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 700);
  };

  return (
    <ContactWrapper id="contact">
      {/* <div className="Container">
        <div className="SectionTitle">// Contact</div>
        <div className="BigCard">
          <Email>
            <div style={{ display: 'flex', alignItems: 'center', columnGap: '20px', rowGap: '10px', flexWrap: 'wrap', justifyContent: 'center' }} >
              <span>markusjnilsson@hotmail.com</span>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                open={showTooltip}
                onClose={() => setShowTooltip(false)}
                title="Copied!"
                TransitionComponent={Zoom}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                placement="bottom"
              >
                <IconButton onClick={copyToClipboard} >
                  <MdContentCopy size={25} style={{ cursor: 'pointer', color: "#151418" }} />
                </IconButton>
              </Tooltip>
            </div>
            <a
              className="btn PrimaryBtn btn-shadow"
              href="./markusjnilsson@hotmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send Email
            </a>
          </Email>
        </div>
      </div> */}
    </ContactWrapper>
  );
}

export default Contact;
